import jwtDecode from 'jwt-decode';

type Groups = 'Traders' | 'Subscribers' | 'UAT';

type JWTPayload = {
  oai: string;
  exp: number;
  groups?: Groups[];
  email?: string;
  mobile_phone?: string;
  mobile_verified?: boolean;
  sub: string;
  cboe_status?: 'activated' | 'deactivated';
};

export const parseToken = (token?: string) => {
  if (!token) {
    return undefined;
  }

  try {
    return jwtDecode<JWTPayload>(token);
  } catch (e) {
    return undefined;
  }
};
